export { UserService } from '../../buupass-auth/services/user.service';
